document.addEventListener("DOMContentLoaded", () => {
  const updateAllPreviewButtons = () => {
    document.querySelectorAll(".tee-preview-button__text").forEach((btn) => {
      if (btn.textContent !== "Vis design") {
        btn.textContent = "Vis design";
      }
    });
  };

  updateAllPreviewButtons();

  const observer = new MutationObserver(updateAllPreviewButtons);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});